import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { BusinessEntityResource } from 'src/app/interfaces/business-entity-resource';
import { EventReservationResource } from 'src/app/interfaces/event-reservation-resource';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { EventService } from 'src/app/services/event.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { Sort } from '@angular/material/sort';
import { ReservationSlotResource } from 'src/app/interfaces/reservation-slot-resource';

@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.scss']
})
export class ReservationComponent implements OnInit {
  /**
   * The Headers of the table
   */
  @ViewChild(MatSort) sort: MatSort;
  /**
   * The data to be displayed
   */
  dataSource: MatTableDataSource<any>;
  /**
   * The Columns  of the Table
   */
  displayedColumns = ['select', 'voucherKey', 'event.title', 'event.partner.name', 'attendingAccount.displayName', 'created', 'state', 'paymentstate', 'menu']; //'Kontaktdaten',
  /**
   * The Current page of Reservations
   */
  page = null;
  /**
   * The Form to filter the Events
   */
  filterForm: UntypedFormGroup;
  /**
   * Should the other Filters be visible (Partners)
   */
  showMoreFilter: boolean = false;
  /**
   * Should all Reservations of the current Page be selected
   */
  selectedAll: boolean = false;
  /**
   * Are all selected Reservations printable
   */
  canPrintAllReservations: boolean = false;
  /**
   * Can all selected Reservations be used
   */
  canUseAllReservations: boolean = false;
  /**
   * Can all selected Reservations be canceled
   */
  canCancelAllReservations: boolean = false;
  /**
   * Can all selected Reservations Vouchers be canceled
   */
  canCancelAllVouchers: boolean = false;
  /**
   * The Page MetaData
   */
  pageData = {
    pageIndex: 0,
    pageSize: 12
  }
  /**
   * loading
   */
  loading:boolean = true;
  /**
 * The Options of the EventStateDrowdown
 */
  eventStates = [
    { value: 'DRAFT', viewValue: 'Entwurf' },
    { value: 'PREVIEW', viewValue: 'Vorschau' },
    { value: 'ACTIVE', viewValue: 'Aktiv' },
    { value: 'HIDDEN', viewValue: 'Versteckt' },
    { value: 'CANCELLED', viewValue: 'Abgelehnt' },
    { value: 'EXPIRED', viewValue: 'Abgelaufen' },
    { value: 'ARCHIVED', viewValue: 'Archiviert' },
    { value: 'DELETED', viewValue: 'Gelöscht' },
    { value: "CREATED", viewValue: "Aktiv" }
  ]
  /**
   * The Options of the paymentStatesdropdown
   */
  paymentStates = [
    { value: "NO_PAYMENT", viewValue: "Kostenlos" },
    { value: "PENDING", viewValue: "Nicht bezahlt" },
    { value: "INVOICED", viewValue: "Zugestellt" },
    { value: "PAID", viewValue: "Bezahlt" },
    { value: "CANCELLED", viewValue: "Storniert" }
  ]
  /**
   * The Options of the Statedropdown
   */
  States = [
    { value: "RESERVED", viewValue: "Reserviert" },
    { value: "CANCELLED", viewValue: "Abgelehnt" },
    { value: "USED", viewValue: "Eingelöst" },
    { value: "NEW", viewValue: "Neu" },
    { value: "FAILED", viewValue: "Fehler" },
    { value: "EXPIRED", viewValue: "Ausgelaufen" },
    { value: "REJECTED", viewValue: "Abgelehnt" }
  ]
  /**
   * The Partners in the Partnerfilter
   */
  partners = [];
  /**
   * The currently selected Reservations
   */
  selectedReservations = [];
  /**
   * constructor
   * Init the Forms
   * @param eventService 
   * @param fb 
   * @param overlay 
   * @param router 
   * @param route 
   */
  constructor(
    private eventService: EventService,
    private fb: UntypedFormBuilder,
    private overlay: OverlayService,
    private router: Router,
    private route: ActivatedRoute) {
    this.filterForm = this.fb.group({
      customerPublicIds: null,
      eventPartnerPublicIds: null,
      eventPublicId: null,
      eventStates: null,
      filterByPaymentStates: null,
      filterByStates: null,
      searchTerm: null,
      voucherKey: null
    })

    this.eventService.getPartners().subscribe((partners: PagedResources<BusinessEntityResource>) => {
      this.partners = partners.content
    })

    this.route.queryParams.subscribe(params => {
      this.filterForm.markAllAsTouched();
      this.filterForm.patchValue({
        customerPublicIds: params?.customerPublicIds,
        eventPartnerPublicIds: params?.eventPartnerPublicIds,
        eventPublicId: params?.eventPublicId,
        eventStates: ((params?.eventStates != '') ? params?.eventStates?.split(',') : null),
        filterByPaymentStates: ((params?.filterByPaymentStates != '') ? params?.filterByPaymentStates?.split(',') : null),
        filterByStates: ((params?.filterByStates != '') ? params?.filterByStates?.split(',') : null),
        searchTerm: params?.searchTerm,
        voucherKey: params?.voucherKey
      })
      if (params?.page) {
        this.pageData.pageIndex = params?.page;
      }
      if (params?.size) {
        this.pageData.pageSize = params?.size;
      }
    })
  }
  /**
   * ngOnInit
   * load the First List of Reservations
   */
  ngOnInit() {
    this.eventService.searchForEventReservations(this.pageData.pageIndex, this.pageData.pageSize, "created,desc", this.filterForm.value.filterByStates, this.filterForm.value.filterByPaymentStates, this.filterForm.value.eventPartnerPublicIds, this.filterForm.value.searchTerm, this.filterForm.value.eventPublicId, this.filterForm.value.eventStates).subscribe((push: any) => {
      this.page = push.page
      push.content.forEach(newelement => {
        this.selectedReservations.forEach(element => {
          if (newelement.publicId == element.publicId) {
            if (element['selected'] == true) {
              newelement['selected'] = true;
            } else {
              newelement['selected'] = false;
            }
          }
        });
      });
      this.dataSource = new MatTableDataSource(push.content);
      this.loading = false;
    })
  }
  /**
   * Load a Page of Reservations
   * @param event 
   */
  loadPage(event?: PageEvent) {
    this.pageData.pageIndex = event.pageIndex;
    this.pageData.pageSize = event.pageSize;
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          page: event.pageIndex,
          size: event.pageSize,
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        return this.search(event.pageIndex, event.pageSize);
      })
  }

  /**
   * Search for the Reservations based on the Filter
   * @param pageIndex 
   * @param pageSize 
   */
  search(pageIndex, pageSize) {
    this.eventService.searchForEventReservations(pageIndex, pageSize, "created,desc", this.filterForm.value.filterByStates, this.filterForm.value.filterByPaymentStates, this.filterForm.value.eventPartnerPublicIds, this.filterForm.value.searchTerm, this.filterForm.value.eventPublicId, this.filterForm.value.eventStates).subscribe((push: any) => {
      this.page = push.page
      this.pageData.pageIndex = pageIndex;
      this.pageData.pageSize = pageSize;
      push.content.forEach(newelement => {
        this.selectedReservations.forEach(element => {
          if (newelement.publicId == element.publicId) {
            if (element['selected'] == true) {
              newelement['selected'] = true;
            } else {
              newelement['selected'] = false;
            }
          }
        });
      });
      this.dataSource = new MatTableDataSource(push.content);
    })
  }
  /**
   * Filter the Reservations based on the Filter
   */
  filterReservations() {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        customerPublicIds: this.filterForm.value?.customerPublicIds,
        //TODO Fix the filter by url for partners
        // eventPartnerPublicIds: this.filterForm.value?.eventPartnerPublicIds,
        eventPublicId: this.filterForm.value?.eventPublicId,
        eventStates: this.filterForm.value?.eventStates?.join(),
        filterByPaymentStates: this.filterForm.value?.filterByPaymentStates?.join(),
        filterByStates: this.filterForm.value?.filterByStates?.join(),
        searchTerm: this.filterForm.value?.searchTerm,
        voucherKey: this.filterForm.value?.voucherKey,
        page: this.pageData.pageIndex,
        size: this.pageData.pageSize
      },
      queryParamsHandling: 'merge'
    }).then(() => {
      let eventPartnerPublicIds = [];
      if (this.filterForm.value.eventPartnerPublicIds != null) {
        if (this.filterForm.value.eventPartnerPublicIds?.length != 0) {
          this.filterForm.value.eventPartnerPublicIds.forEach(element => {
            eventPartnerPublicIds.push(element.publicId);
          });
        }
      }
      this.eventService.searchForEventReservations(this.pageData.pageIndex, this.pageData.pageSize, "created,desc", this.filterForm.value.filterByStates, this.filterForm.value.filterByPaymentStates, eventPartnerPublicIds, this.filterForm.value.searchTerm, this.filterForm.value.eventPublicId, this.filterForm.value.eventStates).subscribe((push: any) => {
        this.page = push.page
        push.content.forEach(element => {
          element['selected'] = false;
        });
        this.selectedAll = false;
        this.selectedReservations = [];
        this.dataSource = new MatTableDataSource(push.content);
      })
    })
  }
  /**
   * Show more of the Filters
   */
  showmoreFilters() {
    this.showMoreFilter = true;
  }
  /**
   * Show less of the Filters
   */
  showLessFilters() {
    this.showMoreFilter = false;
  }
  /**
   * Reset the Filter
   */
  resetFilter() {
    this.filterForm.reset();
    this.search(this.pageData.pageIndex, this.pageData.pageSize);
  }
  /**
   * ngAfterViewInit
   * Look for change on the sort Headers
   */
  ngAfterViewInit() {
    //Look for change on the sort Headers
    this.sort?.sortChange.subscribe(value => {
      if (value.direction == '') {
        this.dataSource = new MatTableDataSource(this.shuffle(this.dataSource.data));
      } else {
        this.eventService.searchForEventReservations(this.pageData.pageIndex, this.pageData.pageSize, value.active + "," + value.direction, this.filterForm.value.filterByStates, this.filterForm.value.filterByPaymentStates, this.filterForm.value.eventPartnerPublicIds, this.filterForm.value.searchTerm, this.filterForm.value.eventPublicId, this.filterForm.value.eventStates).subscribe((push: any) => {
          this.page = push.page
          push.content.forEach(element => {
            element['selected'] = false;
          });
          this.dataSource = new MatTableDataSource(push.content);
          this.selectedAll = false;
          this.selectedReservations = [];
        })
      }
    })
  }
  /**
   * Get the PDF to a Reservation
   * @param resID 
   */
  getPDF(resID) {
    this.eventService.getPDF(resID).subscribe(blob => {
      console.log(blob)
      var file = new Blob([blob], { type: 'application/pdf' });
      let pdf = URL.createObjectURL(file);
      window.open(pdf)
    })
  }
  /**
   * Set the State to CANCELLED
   * @param resID 
   */
  delteReservation(resID) {
    this.eventService.delteReservation(resID).subscribe(FromStateChange => {
      if (FromStateChange == null) {
        this.overlay.openSnackBar("Gutschein erfolgreich storniert!");
        this.filterReservations();
      }
    })
  }
  /**
   * Set the State to RESERVED
   * @param resID 
   */
  delteAlreadyUsesReservation(resID) {
    this.eventService.delteAlreadyUsesReservation(resID).subscribe(FromStateChange => {
      if (FromStateChange == null) {
        this.overlay.openSnackBar("Einlösung erfolgreich storniert!");
        this.filterReservations();
      }
    })
  }

  /**
   * Use the Reservation
   * @param resID 
   */
  useReservation(resID) {
    this.eventService.useReservation(resID).subscribe(FromStateChange => {
      if (FromStateChange == null) {
        this.overlay.openSnackBar("Gutschein erfolgreich eingelöst!");
        this.filterReservations();
      }
    })
  }
  /**
   * Check if the Event can be used
   * @param reservation 
   * @returns 
   */
  canUse(reservation: ReservationSlotResource) {
    return reservation.state === 'RESERVED' && reservation.eventV2.eventDiscount != 'RAFFLE';
  };
  /**
   * Check if the Reservation can be reverted
   * @param reservation 
   * @returns 
   */
  canCancelReservationUsage(reservation) {
    return reservation.state === 'USED';
  };
  /**
   * Check if the Reservation can be printed
   * @param reservation 
   * @returns 
   */
  canPrint(reservation: ReservationSlotResource) {
    return reservation.state !== 'CANCELLED' && reservation.eventV2.eventDiscount != 'RAFFLE';
  };
  /**
   * Check if the Reservation can be canceled
   * @param reservation 
   * @returns 
   */
  canCancel(reservation) {
    return reservation.state === 'RESERVED' && (
      reservation.paymentState === 'NO_PAYMENT' ||
      reservation.paymentState === 'INVOICED' ||
      reservation.paymentState === 'PENDING'
    );
  }
  /**
   * Select a single Reservation
   */
  selectReservation(res: EventReservationResource) {
    if (this.selectedReservations.filter(function (e) { return e.publicId === res.publicId; }).length > 0) {
      res['selected'] = false;
      this.selectedReservations.splice(this.selectedReservations.indexOf(res), 1);
    } else {
      res['selected'] = true;
      this.selectedReservations.push(res);
    }
    this.genValuesForAll();
  }
  /**
   * Select all Elements on the current Page
   */
  selectAll() {
    this.selectedReservations = [];
    if (this.selectedAll) {
      this.dataSource.data.forEach(element => {
        this.selectedReservations.splice(this.selectedReservations.indexOf(element), 1);
        element['selected'] = false;
        this.selectedAll = false;
      });
    } else {
      this.dataSource.data.forEach(element => {
        this.selectedReservations.push(element);
        element['selected'] = true;
        this.selectedAll = true;
        this.genValuesForAll();
      });
    }

    if (this.selectedReservations.length == 0) {
      this.canCancelAllVouchers = false;
      this.canCancelAllReservations = false;
      this.canUseAllReservations = false;
      this.canPrintAllReservations = false;
    }
  }
  /**
   * print a selected Reservations
   */
  printAllReservations() {
    this.selectedReservations.forEach((element: EventReservationResource) => {
      this.getPDF(element.publicId);
    });
  }
  /**
   * cancel a selected Reservations
   */
  cancelAllReservations() {
    this.selectedReservations.forEach((element: EventReservationResource) => {
      this.delteAlreadyUsesReservation(element.publicId);
    });
  }
  /**
   * cancel a selected Vouchers
   */
  cancelAllVouchers() {
    this.selectedReservations.forEach((element: EventReservationResource) => {
      this.delteReservation(element.publicId);
    });
  }
  /**
   * use a selected Reservations
   */
  useAllReservations() {
    this.selectedReservations.forEach((element: EventReservationResource) => {
      this.useReservation(element.publicId);
    });
  }
  /**
   * Check wich menuoptions can be pressed
   */
  genValuesForAll() {
    if (this.selectedReservations.length != 0) {
      this.canPrintAllReservations = this.selectedReservations.every(function (e) {
        if (e.state !== 'CANCELLED') {
          return true;
        } else {
          return false;
        }
      });

      this.canUseAllReservations = this.selectedReservations.every(function (e) {
        if (e.state === 'RESERVED') {
          return true;
        } else {
          return false;
        }
      });

      this.canCancelAllReservations = this.selectedReservations.every(function (e) {
        if (e.state === 'USED') {
          return true;
        } else {
          return false;
        }
      });


      this.canCancelAllVouchers = this.selectedReservations.every(function (e) {
        if (e.state === 'RESERVED' && (e.paymentState === 'NO_PAYMENT' || e.paymentState === 'INVOICED' || e.paymentState === 'PENDING')) {
          return true;
        } else {
          return false;
        }
      });
    } else {
      this.canCancelAllVouchers = false;
      this.canCancelAllReservations = false;
      this.canUseAllReservations = false;
      this.canPrintAllReservations = false;
    }
  }
  /**
   * Create a random new Date 
   * @param arr 
   * @returns 
   */
  shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1)); //random index
      [arr[i], arr[j]] = [arr[j], arr[i]]; // swap
    }
    return arr;
  }
  /**
   * Filter the Event is the User presses Enter in the Search Field
   * @param event 
   */
  onKeydown(event) {
    if (event.key === "Enter") {
      this.filterReservations()
    }
  }
}

